export const NAVIGATION = "navigation"
export const FAVORITES = "favorites"
